import { useMutation } from '@tanstack/react-query'

import type { BookingSpecificityDetail, CreateBookingSpecificityPayload } from '../../types/booking-specificity.js'

import { apiClient } from '../../lib/client.js'

export const useCreateSessionSpecificityMutation = () => {
  return useMutation({
    mutationFn: async ({
      sessionId,
      ...data
    }: CreateBookingSpecificityPayload & { sessionId: string }) => {
      const response = await apiClient.client.post<BookingSpecificityDetail>(
        `/booking-session/${sessionId}/specificity`,
        data
      )
      return response.data
    },
  })
}
